const form = document.getElementById('trackingForm');
const statusBox = document.getElementById('status');
const results = document.getElementById('results');
const timeline = document.getElementById('timeline');
const submitButton = document.getElementById('trackingSubmitBtn');
const API_BASE = 'https://xyz.vitabiotics.com';

function setStatus(type, message) {
  statusBox.className = 'status show ' + type;
  statusBox.textContent = message;
}

function clearStatus() {
  statusBox.className = 'status';
  statusBox.textContent = '';
}

function formatDate(value) {
  if (!value) return '—';

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
}

function renderTimeline(events) {
  if (!events || !events.length) {
    timeline.innerHTML = '<div class="empty">No tracking events available yet.</div>';
    return;
  }

  timeline.innerHTML = events.map(event => `
    <div class="event">
      <div class="event-date">${formatDate(event.EventDateUtc || event.eventDateUtc)}</div>
      <h3 class="event-title">${escapeHtml(event.Type || event.type || 'Update')}</h3>
      <p class="event-desc">${escapeHtml(event.Description || event.description || '')}${(event.Location || event.location) ? '<br><strong>Location:</strong> ' + escapeHtml(event.Location || event.location) : ''}</p>
    </div>
  `).join('');
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function getQueryParams() {
  const params = new URLSearchParams(window.location.search);

  return {
    order: params.get('orderNo') || '',
    tracking: params.get('selectedTrackingNo') || ''
  };
}

function fillSummary(data, orderInput) {
  const trackingData = data.trackingResult || data;
  const carrier = trackingData.Carrier || trackingData.carrier || data.company || '—';
  const trackingNumber = trackingData.TrackingNumber || trackingData.trackingNumber || data.tracking || '—';
  const status = trackingData.Status || trackingData.status || 'In progress';
  const summary = trackingData.Summary || trackingData.summary || 'Latest tracking update received.';
  const deliveredAt = trackingData.DeliveredAtUtc || trackingData.deliveredAtUtc;
  const events = trackingData.Events || trackingData.events || [];
  const orderId = data.orderId || data.OrderId || '';

  document.getElementById('summaryTitle').textContent = summary;
  document.getElementById('summaryRef').textContent = orderId ? `Order ${orderInput} • ${orderId}` : `Order ${orderInput}`;
  document.getElementById('carrier').textContent = carrier;
  document.getElementById('trackingNumber').textContent = trackingNumber;
  document.getElementById('statusText').textContent = status;
  document.getElementById('deliveredAt').textContent = formatDate(deliveredAt);

  const badge = document.getElementById('summaryBadge');
  badge.style.display = 'inline-flex';
  badge.textContent = status;

  renderTimeline(events);
  results.classList.add('show');
}

async function getTrackingToken(order, tracking) {
  const response = await fetch(
    `${API_BASE}/tracking-token?order=${encodeURIComponent(order)}&tracking=${encodeURIComponent(tracking)}`,
    {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    }
  );

  if (!response.ok) {
    throw new Error('Could not generate secure request token.');
  }

  const data = await response.json();

  if (!data || data.success === false || !data.token || !data.ts) {
    throw new Error((data && data.message) ? data.message : 'Token request failed.');
  }

  return data;
}

form.addEventListener('submit', async function (e) {
  e.preventDefault();
  clearStatus();
  results.classList.remove('show');
  timeline.innerHTML = '';

  const order = document.getElementById('order').value.trim();
  const tracking = document.getElementById('tracking').value.trim();

  if (!order || !tracking) {
    setStatus('error', 'Please enter both your order number and tracking number.');
    return;
  }

  setStatus('loading', 'Checking your tracking details...');

  try {
    const tokenData = await getTrackingToken(order, tracking);

    const response = await fetch(
      `${API_BASE}/tracking-order?order=${encodeURIComponent(order)}&tracking=${encodeURIComponent(tracking)}&token=${encodeURIComponent(tokenData.token)}&ts=${encodeURIComponent(tokenData.ts)}`,
      {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      }
    );

    if (!response.ok) {
      throw new Error('The tracking request failed.');
    }

    const data = await response.json();

    if (!data || data.success === false) {
      setStatus('error', (data && data.message) ? data.message : 'We could not find that order.');
      return;
    }

    fillSummary(data, order);
    setStatus('success', 'Tracking details loaded successfully.');
  } catch (error) {
    setStatus('error', error.message || 'Something went wrong while loading tracking details.');
  }
});

window.addEventListener('load', function () {
  const { order, tracking } = getQueryParams();

  if (order) {
    document.getElementById('order').value = order;
  }

  if (tracking) {
    document.getElementById('tracking').value = tracking;
  }

  if (order && tracking && submitButton) {
    submitButton.click();
  }
});